import * as React from 'react';

const FooterWrapper = (props) => {
  const { customStyle, className } = props;

  return (
    <div
      className={props.className ? `m__foot ` + props.className : `m__foot`}
      style={props.customStyle}
    >
      <div className="m__foot__btns">
        {props.children}
      </div>
    </div>
  )
};

export default FooterWrapper;
